import { observer } from 'mobx-react';
import { QuoteSummary } from '../quoteSummary/quoteSummary'

export const QuoteSummaryStep = observer(({ store, substep }) => {
  return <QuoteSummary store={store} />
});